import React, { Component } from 'react';
import '../css/getFormasPedido.css';
class getFormasPedido extends Component {
  constructor(props){
    super(props);
    this.state = {
      mesa : this.props.id_mesa,
      accion:'',
      id_forma_entrega:0,
      msg:'',
      valor_pago_efectivo:0
    }
  }
  get_new_pedido=(id_forma_entrega)=>{
    if(Number(id_forma_entrega)===3){
      this.setState({
        accion:'mesa',
        id_forma_entrega
      })
    }else{
      const id_forma_pago = this.props.id_forma_pago
      if(Number(id_forma_pago)===0){
        if(Number(id_forma_entrega)===0){
          this.setState({
            accion:'domicilio',
            id_forma_entrega
          })
        }
        if(Number(id_forma_entrega)===1||Number(id_forma_entrega)===5){
          this.setState({
            accion:'llevar',
            id_forma_entrega
          })
        }
      }else{
        this.props.get_new_pedido(id_forma_entrega,this.state.mesa,0)
      }
      //
    }
  }
  getValidarMesa =()=>{
      const id_forma_pago = this.props.id_forma_pago
      if(Number(id_forma_pago)===0){
        if(Number(this.state.mesa)>0&&Number(this.state.valor_pago_efectivo)>0){
          this.props.get_new_pedido(3,this.state.mesa,
            Number(this.state.valor_pago_efectivo))
        }else{
          if(Number(this.state.valor_pago_efectivo)===0){
            this.setState({
              msg:'Seleccione como va a pagar'
            })
          }else{
            this.setState({
              msg:'Ingrese Número de Mesa'
            })
          }
        }
      }else{
        if(Number(this.state.mesa)>0){
          this.props.get_new_pedido(3,this.state.mesa,
            Number(this.state.valor_pago_efectivo))
        }else{
            this.setState({
              msg:'Ingrese Número de Mesa'
            })
        }
      }

  }
  getValidarDomicilio =()=>{
    if(Number(this.state.valor_pago_efectivo)>0){
      this.props.get_new_pedido(this.state.id_forma_entrega,this.state.mesa,Number(this.state.valor_pago_efectivo))
    }else{
      this.setState({
        msg:'Seleccione como va a pagar'
      })
    }
  }
  getValidarLlevar =()=>{
    if(Number(this.state.valor_pago_efectivo)>0){
      this.props.get_new_pedido(this.state.id_forma_entrega,this.state.mesa,Number(this.state.valor_pago_efectivo))
    }else{
      this.setState({
        msg:'Seleccione como va a pagar'
      })
    }
  }


 inputChangedHandlerText = (event) => {
   this.setState({
     mesa :event.target.value
   })
 }
 getDataVuelto =(valor_pago_efectivo)=>{
   this.setState({
     valor_pago_efectivo
   })
 }
 getbilletes = (valor_efectivo)=>{

   const valor = Number(valor_efectivo).toFixed(2)
   let billete1 = Math.floor(valor)+1
   let valor_integer = Math.floor(valor)
   do {
      valor_integer = valor_integer + 1
      var resto = valor_integer % 5;
      if ( resto === 0 ){
        break;
      }
   }while (true);
   let billete5 = valor_integer
   valor_integer = Math.floor(valor)
   do {
      valor_integer = valor_integer + 1
      var resto1 = valor_integer % 10;
      if ( resto1 === 0 ){
        break;
      }
   }while (true);
   let billete10 = valor_integer
   valor_integer = Math.floor(valor)
   do {
      valor_integer = valor_integer + 1
      var resto2 = valor_integer % 20;
      if ( resto2 === 0 ){
        break;
      }
   }while (true);
   let billete20 = valor_integer
   if(valor===billete1){
      billete1 = 0
   }
   if(valor===billete5){
      billete5 = 0
   }
   if(valor===billete10){
      billete10 = 0
   }
   if(valor===billete20){
      billete20 = 0
   }

   if(billete1===billete5){
      billete5 = 0
   }
   if(billete1===billete10){
      billete10 = 0
   }
   if(billete1===billete20){
      billete20 = 0
   }

   if(billete5===billete10){
      billete10 = 0
   }
   if(billete5===billete20){
      billete20 = 0
   }

   if(billete10===billete20){
      billete20 = 0
   }
   const valor_pago_efectivo = this.state.valor_pago_efectivo
   return(
      <React.Fragment>
        {(Number(valor)>0)?
          <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
            <div onClick={ () => this.getDataVuelto(valor)} className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(valor))?"#229954":"#82E0AA","borderRadius": "15px"}}>
              <span className="span-global" style={{"color":"white"}} >{valor}$</span>
            </div>
          </div>
          :''}
        {(Number(billete1)>0)?
          <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
            <div onClick={ () => this.getDataVuelto(billete1)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete1))?"#229954":"#82E0AA","borderRadius": "15px"}}>
              <span className="span-global" style={{"color":"white"}}>{billete1}$</span>
            </div>
          </div>
          :''}
        {(Number(billete5)>0)?
          <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
            <div onClick={ () => this.getDataVuelto(billete5)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete5))?"#229954":"#82E0AA","borderRadius": "15px"}}>
              <span className="span-global" style={{"color":"white"}} >{billete5}$</span>
            </div>
          </div>
          :''}
        {(Number(billete10)>0)?
          <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
            <div onClick={ () => this.getDataVuelto(billete10)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete10))?"#229954":"#82E0AA","borderRadius": "15px"}}>
              <span className="span-global" style={{"color":"white"}} >{billete10}$</span>
            </div>
          </div>
          :''}
        {(Number(billete20)>0)?
        <div className="cssversion_pxh50 cssversion_pxw70 cssversion_contentCenter" style={{"display":"flex"}}>
          <div onClick={ () => this.getDataVuelto(billete20)}className="cssversion_pxh40 cssversion_pxw60 cssversion_contentCenter" style={{"display":"flex","backgroundColor":(Number(valor_pago_efectivo)===Number(billete20))?"#229954":"#82E0AA","borderRadius": "15px"}}>
          <span className="span-global" style={{"color":"white"}}>{billete20}$</span>
          </div>
        </div>
        :''}
      </React.Fragment>
   )
 }

 getIngresaLlevar = ()=>{
   let valor_efectivo = this.props.total_precio;
   return (
     <React.Fragment>
     <div className="cssversion_menu cssversion_colorprimario">
       <div className="cssversion_pw100 cssversion_ph85 cssversion_colorblanco " >
         <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}} >
           <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
             <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  />
           </div>
           <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
             <span className="span-global-link" >EFECTIVO</span>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh90">
           <span className="span-global">Seleccione como va a pagar</span>
           <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex"}} >
             {this.getbilletes(valor_efectivo)}
           </div>
         </div>
          <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <button style={{"width":"95%"}} className={(Number(this.state.valor_pago_efectivo)===0)? "button-global-disabled":"button-global"}  onClick={ () => this.getValidarLlevar()}>Finalizar</button>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             {(this.state.msg)?
             <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
               <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
             </div>
             :''}
           </div>
         </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph15 cssversion_colorblanco cssversion_contentCenter" >
          <button style={{"width":"95%"}} className="button-global" onClick={ () => this.props.get_go_to_sub("")}>Regresar</button>
        </div>
      </div>
     </React.Fragment>
   )
 }
 getIngresaDomicilio = ()=>{
   let valor_efectivo = this.props.total_final;
   return (
     <React.Fragment>
     <div className="cssversion_menu cssversion_colorprimario">
       <div className="cssversion_pw100 cssversion_ph85 cssversion_colorblanco " >
         <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}} >
           <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
             <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  />
           </div>
           <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
             <span className="span-global-link" >EFECTIVO</span>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh90">
           <span className="span-global">Seleccione como va a pagar</span>
           <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex"}} >
             {this.getbilletes(valor_efectivo)}
           </div>
         </div>
          <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <button style={{"width":"95%"}} className={(Number(this.state.valor_pago_efectivo)===0)? "button-global-disabled":"button-global"} onClick={ () => this.getValidarDomicilio()}>Finalizar</button>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             {(this.state.msg)?
             <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
               <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
             </div>
             :''}
           </div>
         </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph15 cssversion_colorblanco cssversion_contentCenter" >
          <button style={{"width":"95%"}} className="button-global" onClick={ () => this.props.get_go_to_sub("")}>Regresar</button>
        </div>
      </div>
     </React.Fragment>
   )
 }

 getIngresaMesa =()=>{
   let valor_efectivo = this.props.total_final;
   const id_forma_pago = this.props.id_forma_pago

   return (
     <React.Fragment>
     <div className="grid-container-global_items_final">
       <div className="container-items-global_final cssversion_colorblanco" >
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <span className="span-global">Ingrese Número de Mesa</span>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <input style={{"textAlign":"center","fontSize":"16pt"}} value={this.state.mesa} onChange={(event)=>this.inputChangedHandlerText(event)} className="input-global" placeholder="Mesa"
             disabled = {(Number(this.props.id_mesa)>0)? "disabled" : ""} />
           </div>
         </div>
         {(Number(id_forma_pago)===0)?
           <React.Fragment>
             <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}} >
               <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
                 <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/3581574551582004499-128.png') }  />
               </div>
               <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
                 <span className="span-global-link" >EFECTIVO</span>
               </div>
             </div>
             <div className="cssversion_pw100 cssversion_pxh90">
               <span className="span-global">Seleccione como va a pagar</span>
               <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex"}} >
                 {this.getbilletes(valor_efectivo)}
               </div>
             </div>
           </React.Fragment>
         :''}
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             <button style={{"width":"95%"}} className="button-global" onClick={ () => this.getValidarMesa()}>Finalizar</button>
           </div>
         </div>
         <div className="cssversion_pw100 cssversion_pxh60">
           <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
             {(this.state.msg)?
             <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter" style={{"display":"flex","backgroundColor":"#f44336","borderRadius": "15px"}}>
               <span className="span-global-link" style={{"color":"white"}}>{this.state.msg}</span>
             </div>
             :''}
           </div>
         </div>
        </div>
        <div className="container-items-buttons_final" >
        <div className="float_button_step_cancelar_final">
          <button style={{"width":"95%"}} className="button-global" onClick={ () => this.props.get_go_to_sub("")}>Regresar</button>
        </div>
        </div>
      </div>
     </React.Fragment>
   )
 }
 getListaFormasPago =()=>{
   const lat = this.props.lon
   //console.log(lat)
   /*          <div className="lbl_forma_reserva" onClick={ () => this.get_new_pedido(2)}>
               PEDIDO PARA RESERVARLO
             </div>
             <div className="lbl_forma_mesa" onClick={ () => this.get_new_pedido(3)}>
               PEDIDO A LA MESA
             </div>

             <div className="lbl_imagen_reserva" onClick={ () => this.get_new_pedido(2)}>
             <img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/iconfinder_24_hour_3387321.png') }  />
             </div>
             <div className="lbl_imagen_mesa" onClick={ () => this.get_new_pedido(3)}>
             <img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/45428.png') }  />
             </div>
             */
             //console.log(this.props.sucursal)
   return (
     <React.Fragment>
     <div className="cssversion_menu cssversion_colorprimario">
       <div className="cssversion_pw100 cssversion_ph85 cssversion_colorblanco " >
         <div className="cssversion_pw100 cssversion_pxh110" style={(Number(lat)===0)?{"display":"none"}:{"display":"flex"}} onClick={ () => this.get_new_pedido(0)} >
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido_">Pedido a Domicilio</div>
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido"><img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/iconfinder_Delivery_3387313.png') }  /></div>
         </div>
         <br/><br/>
         <div className="cssversion_pw100 cssversion_pxh110" style={{"display":"flex"}} onClick={ () => this.get_new_pedido(1)}>
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido_">Pedido para Retirar</div>
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido"><img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/iconfinder_Market_3387301.png') }  /></div>
         </div>
         <br/><br/>
         <div className="cssversion_pw100 cssversion_pxh110"  style={(!this.props.sucursal)?{"display":"none"}:{"display":"flex"}}  onClick={ () => this.get_new_pedido(5)}>
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido_">Consumir en el mismo local</div>
           <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter cssversion_div_forma_pedido"><img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/45428.png') }  /></div>
         </div>
       </div>
       <div className="cssversion_pw100 cssversion_ph15 cssversion_colorblanco cssversion_contentCenter" style={{"display":"flex"}}>
        <button style={{"width":"95%"}} className="button-global" onClick={ () => this.props.get_go_to_sub("")}>Regresar</button>
       </div>
    </div>
     </React.Fragment>
   )
 }
 /*<div className="grid-container-global_items_final">
   <div className="container-items-global_final" >
     <div className="grid-container-formapedido" style={(Number(lat)===0)?{"gridTemplateRows": "0px 120px 120px 120px"}:{"":""}} >
      <div className="lbl_forma_delivery" style={(Number(lat)===0)?{"display":"none"}:{"":""}} onClick={ () => this.get_new_pedido(0)}>
        Pedido a Domicilio
      </div>
      <div className="lbl_forma_retirar" onClick={ () => this.get_new_pedido(1)}>
        Pedido para Retirar
      </div>
      <div className="lbl_forma_reserva" style={(!this.props.sucursal)?{"display":"none"}:{"":""}} onClick={ () => this.get_new_pedido(5)}>
        Consumir en el mismo local
      </div>
      <div className="lbl_imagen_delivery" style={(Number(lat)===0)?{"display":"none"}:{"":""}} onClick={ () => this.get_new_pedido(0)}>
      <img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/iconfinder_Delivery_3387313.png') }  />
      </div>
      <div className="lbl_imagen_retirar" onClick={ () => this.get_new_pedido(1)}>
      <img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/iconfinder_Market_3387301.png') }  />
      </div>
      <div className="lbl_imagen_reserva" style={(!this.props.sucursal)?{"display":"none"}:{"":""}}  onClick={ () => this.get_new_pedido(5)}>
      <img style={{"width":"100px"}} alt="Cargando Imagen . . ." src={ require('../image/45428.png') }  />
      </div>
    </div>
    </div>
    <div className="container-items-buttons_final" >
    <div className="float_button_step_cancelar_final">
      <button style={{"width":"95%"}} className="button-global" onClick={ () => this.props.get_go_to_sub("")}>Regresar</button>
    </div>
    </div>
  </div>*/
 render () {
   const accion = this.state.accion
   let modal
   if(accion==='mesa'||Number(this.props.id_mesa)>0){
     modal =<React.Fragment>
            {this.getIngresaMesa()}
            </React.Fragment>
   }else{
     if(accion==='domicilio'){
       modal =<React.Fragment>
              {this.getIngresaDomicilio()}
              </React.Fragment>
     }
     if(accion==='llevar'){
       modal =<React.Fragment>
              {this.getIngresaLlevar()}
              </React.Fragment>
     }
     if(accion===''){
       modal =<React.Fragment>
              {this.getListaFormasPago()}
              </React.Fragment>
     }
   }
   return (
     <React.Fragment>
     {modal}
     </React.Fragment>
   )
 }

}
export default getFormasPedido;
